import { transport } from 'config/transport';

export function callApiExportCongDoanVungReportMonthly(yearMonth, pdf = false) {
    return transport.get(`/trunguong/congdoanvung/report/exportReport`, { params: { yearMonth, pdf }, responseType: 'blob' });
}
